import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class CornerLeftUpIconService {

    render() {
        return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.29289 3.29289C8.68342 2.90237 9.31658 2.90237 9.70711 3.29289L14.7071 8.29289C15.0976 8.68342 15.0976 9.31658 14.7071 9.70711C14.3166 10.0976 13.6834 10.0976 13.2929 9.70711L9 5.41421L4.70711 9.70711C4.31658 10.0976 3.68342 10.0976 3.29289 9.70711C2.90237 9.31658 2.90237 8.68342 3.29289 8.29289L8.29289 3.29289Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3C9.55228 3 10 3.44772 10 4V16C10 16.7956 10.3161 17.5587 10.8787 18.1213C11.4413 18.6839 12.2044 19 13 19H20C20.5523 19 21 19.4477 21 20C21 20.5523 20.5523 21 20 21H13C11.6739 21 10.4021 20.4732 9.46447 19.5355C8.52678 18.5979 8 17.3261 8 16V4C8 3.44772 8.44772 3 9 3Z" fill="black"/>
        </svg>                                
        `;
    }
}
